import {GraphQLClient} from "graphql-hooks"
import memCache from "graphql-hooks-memcache"
import config from "../config"
import {getCookieValue} from "../utils/utils"
import axios from "axios"
import {buildAxiosFetch} from "@lifeomic/axios-fetch"

const gqlAxios = axios.create()
gqlAxios.interceptors.response.use(
  function (response) {
    if (response.status === 401 || response.status === 403)
      window.location.assign(config.api.LOGIN_URL)

    return response
  },
  function (error) {
    console.error("gqlInterceptor.js line 16 - responseError", error)
    return Promise.reject(error)
  }
)
gqlAxios.interceptors.request.use(function (config) {
  config = {
    ...config,
    headers: {
      ...config.headers,
      "x-gt-session": getCookieValue(),
    },
  }
  return config
})

const fixed = config.api.APP_GQL_HOST
const url = fixed + "graphql"
const actualInsightUrl = config.api.INSIGHTS_GQL_HOST

// const useGETForQueries = true; //Using GET for queries can be useful, especially when implementing any sort of HTTP caching strategy.
export const client = new GraphQLClient({
  url,
  fetch: buildAxiosFetch(gqlAxios),
  cache: memCache(),
})

export const insightClient = new GraphQLClient({
  url: actualInsightUrl,
  fetch: buildAxiosFetch(gqlAxios),
  cache: memCache(),
})

// export const mockClient = new GraphQLClient({ url: mockUrl, fetch: buildAxiosFetch(gqlAxios) });
